(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gazette-journal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const index = document.querySelector('[data-gazette-index]');
    if (!index) return;
    const grid = index.querySelector('[data-gazette-grid]');
    const stories = Array.from(index.querySelectorAll('[data-gazette-story]'));
    const empty = index.querySelector('[data-gazette-empty]');
    const filters = Array.from(index.querySelectorAll('[data-gazette-filter]'));
    const sort = index.querySelector('[data-gazette-sort]');
    let activeFilter = 'all';

    const updateStories = () => {
      let visible = 0;
      stories.forEach((story) => {
        const matches = activeFilter === 'all' || story.dataset.tags.split('|').includes(activeFilter);
        story.hidden = !matches;
        if (matches) visible += 1;
      });
      if (empty) empty.hidden = visible > 0;
    };

    filters.forEach((filter) => filter.addEventListener('click', () => {
      activeFilter = filter.dataset.gazetteFilter;
      filters.forEach((item) => item.classList.toggle('is-active', item === filter));
      updateStories();
    }));

    if (sort && grid) sort.addEventListener('change', () => {
      const multiplier = sort.value === 'oldest' ? 1 : -1;
      stories.sort((a, b) => multiplier * (Number(a.dataset.published) - Number(b.dataset.published)));
      stories.forEach((story) => grid.appendChild(story));
      updateStories();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
